import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/header/header.component';
import SideBarMenu from './components/left-side-menu/left-side-menu.component';
import { dashboardSidebarHook } from './hooks/dashboard-sidebar.hook';
import {
  SLayout,
  SSideBar,
  SOutlet,
} from './main-layout.style';

const MainLayoutComponent = (): ReactElement => {
  const sidebar = dashboardSidebarHook();

  return (
    <SLayout>
      <Header />
      <SLayout>
        <SSideBar
          trigger={null}
          collapsible
          collapsed={sidebar.collapsed}
          collapsedWidth={64}
          width={300}
        >
          <SideBarMenu />
        </SSideBar>
        <SOutlet>
          <Outlet />
        </SOutlet>
      </SLayout>
    </SLayout>
  );
};

export default MainLayoutComponent;
